import { mapSupportDescription } from "@/app/common-utils/question/map-support-description";

import {
  AvailbleOptionsType,
  CoverForPageContent,
  GroupedCmsDataType,
} from "../types/cover-for.type";

export function groupedCoverForCmsData(cmsData: CoverForPageContent) {
  const cmsDataObj = cmsData.overlayArea[0];

  const userHeaderSection =
    cmsDataObj.assistantDescription?.[0]?.userHeaderSection;

  const filteredAssistantBodySection = userHeaderSection
    ? Object.fromEntries(Object.entries(userHeaderSection).slice(1))
    : undefined;

  const familyData = {
    headerText: cmsDataObj.familyHeadingText,
    subText: cmsDataObj.familySubText,
    descriptionSection: {
      title: cmsDataObj?.familyDescription?.[0].title ?? "",
      body:
        mapSupportDescription(
          cmsDataObj?.familyDescription?.[0].questionBody
        ) ?? "",
      isLoadMoreButton: cmsDataObj?.familyLoadMoreButton ?? false,
      drawerData: cmsDataObj.familySupportDrawer,
    },
  };

  const groupedCmsData = {
    INDIVIDUAL: {
      headerText: cmsDataObj.individualHeadingText,
      subText: cmsDataObj.individualSubText,
      descriptionSection: {
        title: cmsDataObj?.individualDescription?.[0].title ?? "",
        body:
          mapSupportDescription(
            cmsDataObj?.individualDescription?.[0].questionBody
          ) ?? "",
        isLoadMoreButton: cmsDataObj?.individualLoadMoreButton ?? false,
        drawerData: cmsDataObj.individualSupportDrawer,
      },
    },
    COUPLE: {
      headerText: cmsDataObj.coupleHeadingText,
      subText: cmsDataObj.coupleSubText,
      descriptionSection: {
        title: cmsDataObj?.coupleDescription?.[0].title ?? "",
        body:
          mapSupportDescription(
            cmsDataObj?.coupleDescription?.[0].questionBody
          ) ?? "",
        isLoadMoreButton: cmsDataObj?.coupleLoadMoreButton ?? false,
        drawerData: cmsDataObj.coupleSupportDrawer,
      },
    },
    FAMILY: familyData,
    SINGLE_PARENT_FAMILY: familyData,
    OTHER: {
      headerText: cmsDataObj.groupHeadingText,
      subText: cmsDataObj.groupSubText,
      descriptionSection: {
        title: cmsDataObj?.groupDescription?.[0].title ?? "",
        body:
          mapSupportDescription(
            cmsDataObj?.groupDescription?.[0].questionBody
          ) ?? "",
        isLoadMoreButton: cmsDataObj?.groupLoadMoreButton ?? false,
        drawerData: cmsDataObj.groupSupportDrawer,
      },
    },
    DEFAULT: {
      headerText: "",
      subText: "",
      descriptionSection: {
        title:
          cmsDataObj?.assistantDescription?.[0].userHeaderSection[0].text ?? "",
        body: mapSupportDescription(filteredAssistantBodySection) ?? "",
        isLoadMoreButton: cmsDataObj?.loadMoreButton ?? false,
        drawerData: cmsDataObj.defaultSupportDrawer,
      },
    },
  };

  return groupedCmsData;
}

export function getSingleOptionItem(
  id: AvailbleOptionsType | "DEFAULT",
  cmsGroupedData: GroupedCmsDataType,
  selectedAnswer: AvailbleOptionsType | "DEFAULT"
) {
  const checkIsSelected = () => {
    if (id === "FAMILY") {
      return (
        selectedAnswer === "FAMILY" || selectedAnswer === "SINGLE_PARENT_FAMILY"
      );
    }
    return selectedAnswer === id;
  };
  return {
    id,
    label: cmsGroupedData[id].headerText,
    description: cmsGroupedData[id].subText,
    isSelected: checkIsSelected(),
  };
}

export const numberOfParents = [
  {
    id: 1,
    label: "1",
    value: "SINGLE_PARENT_FAMILY",
  },
  {
    id: 2,
    label: "2",
    value: "FAMILY",
  },
];
